<template>
  <div class="main-content">
    <second-nav-bar></second-nav-bar>
    <div class="content">
      <div class="header">
        <span>校务管理 / 班级管理</span>
      </div>
      <div class="table-container scroll">
        <el-tabs v-model="activeTab" class="zyyj-tabs-custom">
          <el-tab-pane
            v-for="item in schoolGrades"
            :key="item.value"
            :label="item.name"
            :name="item.value"
          >
            <class-tab-content
              v-if="item.value === activeTab"
              :junior="item.value"
              :gradesInfo="schoolGrades"
              :ref="item.value"
            ></class-tab-content>
          </el-tab-pane>
        </el-tabs>
        <div style="position: absolute; right: 20px; top: 10px">
          <el-button
            class="importRelation"
            size="medium"
            @click="importRelation"
            >导入任课关系</el-button
          >
          <el-button type="primary" size="medium" :disabled="$regional.disableCRUD" @click="handleAdd"
            >添加班级</el-button
          >
        </div>
      </div>
    </div>

    <class-edit-box
      :visible.sync="classEditorVisible"
      :identify="classInfo"
      :grades="schoolGrades"
      @edit-result="initData"
    ></class-edit-box>

    <excel-importer-box
      topic="学校"
      :grade="currentGrade"
      action="/acc/teachers/subjects/import"
      template="/acc/teachers/subjects/templates"
      errorUrl="/acc/teachers/subjects/fail/export"
      :visible.sync="importDialogVisible"
      @import-result="initData"
    >
      <template slot="if-failure">
        <el-table-column
          prop="className"
          label="班级"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="subjectName"
          label="任课关系"
          width="100"
        ></el-table-column>
        <el-table-column prop="message" label="失败原因"></el-table-column>
      </template>
    </excel-importer-box>
  </div>
</template>

<script>
import _ from 'lodash'
import SecondNavBar from '@/components/common/SecondNavBar'
import ClassTabContent from '@/components/school-admin/affair/ClassTabContent'
import ClassEditor from '@/components/school-admin/affair/ClassEditor'
import ExcelImporterBox from '@/components/school-admin/affair/ExcelImporterBox'
export default {
  props: [],

  components: {
    'second-nav-bar': SecondNavBar,
    'class-tab-content': ClassTabContent,
    'class-edit-box': ClassEditor,
    'excel-importer-box': ExcelImporterBox
  },

  data () {
    return {
      activeTab: '',
      grades: [
        {
          name: '小学',
          value: 1,
          children: [
            {
              name: '一年级',
              value: '1'
            },
            {
              name: '二年级',
              value: '2'
            },
            {
              name: '三年级',
              value: '3'
            },
            {
              name: '四年级',
              value: '4'
            },
            {
              name: '五年级',
              value: '5'
            },
            {
              name: '六年级',
              value: '6'
            }
          ]
        },
        {
          name: '初中',
          value: 2,
          children: [
            {
              name: '初一年级',
              value: '7'
            },
            {
              name: '初二年级',
              value: '8'
            },
            {
              name: '初三年级',
              value: '9'
            }
          ]
        },
        {
          name: '高中',
          value: 3,
          children: [
            {
              name: '高一年级',
              value: '10'
            },
            {
              name: '高二年级',
              value: '11'
            },
            {
              name: '高三年级',
              value: '12'
            }
          ]
        },
        {
          name: '九年一贯',
          value: 4,
          children: [
            {
              name: '一年级',
              value: '1'
            },
            {
              name: '二年级',
              value: '2'
            },
            {
              name: '三年级',
              value: '3'
            },
            {
              name: '四年级',
              value: '4'
            },
            {
              name: '五年级',
              value: '5'
            },
            {
              name: '六年级',
              value: '6'
            },
            {
              name: '七年级',
              value: '7'
            },
            {
              name: '八年级',
              value: '8'
            },
            {
              name: '九年级',
              value: '9'
            }
          ]
        }
      ],
      editorVisible: false,
      teacherInfo: {},
      classInfo: {},
      classEditorVisible: false,
      gradesInfo: {},
      importDialogVisible: false
    }
  },

  watch: {

  },

  computed: {
    schoolGrades () {
      return _.filter(this.grades, { value: this.$store.getters['user/getSchoolStage']() })[0].children
    },
    currentGrade () {
      let gradeArr = _.filter(this.schoolGrades, { value: this.activeTab })
      return gradeArr && gradeArr.length > 0 && gradeArr[0]
    }
  },

  mounted () {
    this.initTab()
  },

  methods: {
    initTab () {
      this.activeTab = this.schoolGrades[0].value
    },

    handleAdd () {
      this.classInfo = {}
      this.classEditorVisible = true
    },

    initData () {
      this.$refs[this.activeTab][0].initData()
    },

    importRelation () {
      this.importDialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content {
  width: 100%;
  height: 100%;
  position: relative;
  background: var(--theme-background);
}
.content {
  float: right;
  height: 100%;
  width: calc(100% - 200px);
}
.header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  background: #ffffff;
  border-bottom: tranparent;
  box-shadow: inset 1px 1px 4px 0px rgba(0, 0, 0, 0.12);
}
.header span {
  font-size: 14px;
  color: #757575;
  margin-left: 20px;
}
.table-container {
  width: calc(100% - 80px);
  max-height: calc(100% - 120px);
  overflow: auto;
  margin: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 6px;
  position: relative;
}
/deep/ .el-input__inner {
  height: 36px;
}
/deep/ .el-button--primary.is-plain {
  background: transparent;
}
.el-button--primary.is-plain:hover,
.el-button--primary.is-plain:focus {
  color: var(--theme-color);
  background: transparent;
}
.importRelation /deep/ {
  border-color: var(--theme-color);
  color: var(--theme-color);
}
</style>



// WEBPACK FOOTER //
// src/components/school-admin/affair/ClassManage.vue